const getters = {
  videoPlayer: state => state.state.videoPlayer,
  liveState: state => state.state.liveState,
  height: state => state.state.height
}

export default getters
